import { debounce } from 'lodash'
import { SimpleCache } from '@/utils/cache.utils'
import mixpanel from 'mixpanel-browser'

const cache = new SimpleCache()
const maxPresentationCacheTimeInSeconds = 6
const warmCachePresentationDetails = debounce((dispatch, { presentationId, payloadDataPresentation }) => {
  dispatch('getPresentationDetailsWithCacheAction', {
    presentationId,
    payloadDataPresentation,
    maxAgeInSeconds: maxPresentationCacheTimeInSeconds,
    isPreloading: true,
  })
}, 200)

const warmCachePresentationAttributes = debounce((dispatch, { presentationId }) => {
  dispatch('getPresentationAttributesWithCacheAction', {
    presentationId,
    maxAgeInSeconds: maxPresentationCacheTimeInSeconds,
    isPreloading: true,
  })
}, 200)

const actions = {
  getPresentationAttributesWithCacheAction: async ({ dispatch },
    { presentationId, maxAgeInSeconds, isPreloading }) => {
    const action = 'presentationAttributeModule/fetchPresentationAttributes'
    return cache.invoke(() => {
      if (isPreloading) mixpanel.track('Preload > Presentation attributes', { presentationId })
      return dispatch(
        action,
        presentationId,
        { root: true },
      )
    }, {
      key: `${action}-${presentationId}`,
      maxAgeInSeconds,
    })
  },
  getPresentationDetailsWithCacheAction: async ({ dispatch },
    {
      presentationId, payloadDataPresentation, maxAgeInSeconds, isPreloading,
    }) => {
    const action = 'fetchPresentationDetailsFromAPIAction'
    return cache.invoke(() => {
      if (isPreloading) mixpanel.track('Preload > Presentation details', { presentationId })
      return dispatch(
        action,
        { presentationId, payloadDataPresentation },
        { root: true },
      )
    }, {
      key: `${action}-${presentationId}`,
      maxAgeInSeconds,
    })
  },

  preWarmCachePresentationDetailsAction: ({ dispatch }, { presentationId, payloadDataPresentation }) => {
    warmCachePresentationDetails(dispatch, { presentationId, payloadDataPresentation })
  },

  preWarmCachePresentationAttributesAction: ({ dispatch }, { presentationId }) => {
    warmCachePresentationAttributes(dispatch, { presentationId })
  },
}
const getters = {
  maxPresentationCacheTimeInSeconds: () => maxPresentationCacheTimeInSeconds,
}

export default {
  namespaced: true,
  actions,
  getters,
}
